import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "./rootReducer";
import thunk from "redux-thunk";
import { verifyAuth } from "../../features/auth/authActions";
import { createBrowserHistory } from "history";

export const history = createBrowserHistory();

export function configureStore() {
    console.log("Configuring store...");
    const store = createStore(rootReducer(history), composeWithDevTools(applyMiddleware(thunk)));

    console.log("Initial state:", store.getState());
    console.log("Dispatching verifyAuth...");
    store.dispatch(verifyAuth());
    console.log("State after verifyAuth dispatch:", store.getState());

    return store;
}
